import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { CircleIcon } from 'lucide-react';
import { cva } from 'class-variance-authority';

import { cn } from '@utils/index';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  );
}

const radioVariants = cva(
  "cursor-pointer flex items-center justify-center [&>input[type='radio']:checked+div>span]:opacity-100",
  {
    variants: {
      variant: {
        primary:
          "[&>input[type='radio']:checked+div>span]:bg-primary gap-x-4 text-[26px] size-[29px] border border-radio",
        secondary:
          "[&>input[type='radio']:checked+div>span]:bg-warning gap-x-2 [&>input[type='radio']+div]:border-white [&>input[type='radio']+div]:size-[29px] [&>input[type='radio']+div>span]:size-[25px]",
      },
      disabled: {
        false: null,
        true: ['opacity-50', 'cursor-not-allowed'],
      },
    },
    defaultVariants: {
      variant: 'primary',
      disabled: false,
    },
  }
);

function RadioGroupItem({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  variant?: 'primary' | 'secondary';
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'border-radio text-primary cursor-pointer focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        radioVariants({ variant }),
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className="fill-primary absolute size-[25px]" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
